import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Layout from "../../components/Layout";
import FormFooter from "../../components/FormFooter";
import FormHeader from "../../components/FormHeader";
import Stepper from "../../components/Stepper";
import FormLease from "../../components/FormLease";
import { LEASE_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import { LEASE_INITIAL_VALUES } from "../../constants/initialValues";
import { getPropertyLease, updatePropertyLease } from "../../services/leases";

function LeaseForm(props) {
  const history = useHistory();
  const id = props.match.params?.id;
  const [initialValues, setInitialValues] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id && id !== "add") {
      setIsLoading(true);
      getPropertyLease(id).then((data) => {
        setIsLoading(false);
        setInitialValues(data);
      });
    } else {
      setInitialValues(LEASE_INITIAL_VALUES);
    }
  }, []);

  const onSubmit = (values) => {
    updatePropertyLease(id, values).then((data) => {
      history.push(`/add-property/${id}/unit`);
    });
  };

  if (id && !initialValues) {
    return null;
  }

  return (
    <Layout isLoading={isLoading}>
      <Stepper id={id} currentStepIndex={1} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Paper sx={{ padding: "2rem" }}>
              <FormHeader title="Lease Settings" description="" />
              <Grid container spacing={1}>
                <FormLease />
              </Grid>
            </Paper>
            <FormFooter />
          </form>
        )}
      </Formik>
    </Layout>
  );
}

export default LeaseForm;
